var showHideToggler = document.querySelectorAll(".show-more");

// Show more Mobile
if (showHideToggler) {
    for (var i = 0; i < showHideToggler.length; i++){
        var sibling = showHideToggler[i].previousElementSibling;
        var childCount = sibling.children.length;
        var curText = showHideToggler[i].innerText;

        if (childCount <= 3) {       
            showHideToggler[i].style.display = "none";         
        }

        showHideToggler[i].addEventListener("click", function () {            
            var parent = this.previousElementSibling;
            parent.classList.toggle("open");
            this.style.display="none";

            if (this.innerText == curText) {
                this.querySelector('span').innerText = "+ Vis færre";
            } else {
                this.querySelector('span').innerText = curText;
            }
        }); 
    }
}


// WEBPACK FOOTER //
// ./scripts/components/show-more.js